import { CloseCircleOutlined } from "@ant-design/icons";
import { MiniAlertLabel, MiniAlertText } from "molecules/miniLabels/MiniLabels";

/** Contact Validity.
 * ok: present and valid.
 * missing-ok: not present, but that's ok. not required for selected request channel.
 * warning: present and invalid, but not required for selected request channel.
 * error: present and invalid, and required for selected request channel.
 * missing-error: not present and required for selected request channel.
 */
export type ContactValidity = "ok" | "missing-ok" | "warning" | "error" | "missing-error";

/** Subset of Contact Validity states representing warning or error. */
type ContactValidityWarningError = "warning" | "error" | "missing-error";

/** Properties for Bulk Request contact detail error cell contents. */
interface ContactErrorProps {
    readonly contactValidity: ContactValidityWarningError;
    readonly warningMessage: string;
    readonly errorMessage: string;
    readonly missingErrorMessage: string;
    readonly type: "email" | "phone";
}

/** Bulk Request contact detail error cell contents. */
export const ContactError = ({
    contactValidity,
    warningMessage,
    errorMessage,
    missingErrorMessage,
    type,
}: ContactErrorProps) => {
    switch (contactValidity) {
        case "warning":
            return (
                <MiniAlertLabel
                    aria-label={`Ignored ${type}`}
                    type="info"
                    title={warningMessage}
                    message={`Ignored ${type}`}
                />
            );
        case "error":
            return (
                <MiniAlertText
                    aria-label={`Invalid ${type}`}
                    type="error"
                    icon={<CloseCircleOutlined />}
                    title={errorMessage}
                    message={`Invalid ${type}`}
                    className="mini-label-no-background"
                    placement="topLeft"
                />
            );
        default: // missing-error
            return (
                <MiniAlertText
                    aria-label={`Missing ${type}`}
                    type="error"
                    icon={<CloseCircleOutlined />}
                    title={missingErrorMessage}
                    message={`Missing ${type}`}
                    className="mini-label-no-background"
                    placement="topLeft"
                />
            );
    }
};
